/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let _ET;
let ET;
export default async function EventTarget() {
    return ET || init();
}
async function init() {
    _ET = window.EventTarget;
    try {
        new _ET();
    }
    catch {
        _ET = (await import('event-target-shim')).EventTarget;
    }
    return (ET = _ET);
}
//# sourceMappingURL=EventTarget.js.map